import { http } from '../helpers/HttpApi';
import { DeviceProfile } from 'interfaces';
import { logger } from 'helpers';

export const deviceProfileApi = {
    /**
     * Provides device profile to Kiosk
     */
    getKioskProfile: async () => {
        try {
            const { data } = await http.get<DeviceProfile>(
                `/api/deviceProfile/kiosk`
            );

            if (!data) {
                return null;
            }
            return data;
        } catch (error) {
            logger.logError('Failed to get Kiosk Profile', null, { error });
            console.log('Failed to get Kiosk Profile', { error });
        }
        return null;
    },
};
